import { getUserFavorites, setUserFavorites } from '../../helpers/user';
import { ApiError, send } from '../../scripts/helpers/api';
import { getFieldValidation } from '../../scripts/helpers/fieldValidation';
import { iodine } from '../../scripts/helpers/validation';
import { City, storeLocatorAutocomplete } from "../../scripts/helpers/storeLocator";

interface FilterParams {
  page?: number;
  limit?: number;
  search?: string;
  materials?: string[];
  vitrage?: string[];
  colorGroups?: number[];
}

interface Panel {
    slug: string;
    name: string;
    porte: string;
    subtitle: string;
    url: string;
    defaultColor: {
        color_group_id: number;
        code: string;
        packshot: string | null;
        facade: string | null;
        hexa: string | null;
    };
    colors: Array<{
        color_group_id: number;
        code: string;
        packshot: string | null;
        facade: string | null;
        hexa: string | null;
    }>;
    material: string | null;
    search: string;
}

interface PaginationInfo {
  currentPage: number;
  totalPages: number;
  totalCount: number;
  limit: number;
}

interface ApiResponse {
  panels: Record<string, Panel>;
  pagination: PaginationInfo;
  availableFilters: {
    materials: Array<{ material: string; count: number }>;
    vitrageTypes: Array<{ vitrage_type: string; count: number }>;
    colorGroups: Array<{ id: number; name: string; slug: string; code: string; count: number }>;
  };
}

import Alpine from 'alpinejs';
import {  FavoriteRules } from '../../scripts/types/form';
import {
    updatePageCanonical,
    updatePageMetaTitle,
    updatePageTitle
} from './helpers'
import { AlpineComponentTryba } from '../../scripts/alpine/include/global';

document.addEventListener('alpine:init', () => {
    const panelName = document.querySelector('[x-ref="panelName"]') as HTMLDivElement;
    const panelImage = document.querySelector('[x-ref="panelImage"]') as HTMLImageElement;
    const panelSubtitle = document.querySelector('[x-ref="panelSubtitle"]') as HTMLDivElement;
    const panelReassuranceHeader = document.querySelector('[x-ref="panelReassuranceHeader"]') as HTMLDivElement;
    const panelReassurance = document.querySelector('[x-ref="panelReassurance"]') as HTMLDivElement;
    const panelUrl = document.querySelector('[x-ref="panelUrl"]') as HTMLAnchorElement;
    Alpine.data('initFilters', (): AlpineComponentTryba => {
        return {
            rightLayerOpened: false,
            filtersOpen: false,
            materials: [],
            vitrage: [],
            colorGroups: [],
            allFilter: 0,
            init() {
              this.$store.global.isMobile ? (this.filtersOpen = false) : (this.filtersOpen = true);
              this.getUrlParams();
              this.getAllFiltersNumber();
            },
            preloadFacadeRightPanel(slug: string) {
                if (window['panelsData'] !== null && window['panelsData'][slug] !== undefined) {
                    const panel = window['panelsData'][slug] as Panel;
                    const curImg = new Image();
                    curImg.src = panel.defaultColor.facade ?? panel.defaultColor.packshot ?? '';
                }
            },
            openRightPanel(slug: string) {
                if (window['panelsData'] !== null && window['panelsData'][slug] !== undefined) {
                    const panel = window['panelsData'][slug] as Panel;
                    panelName.textContent = panel.name;
                    panelImage.src = panel.defaultColor.facade ?? panel.defaultColor.packshot ?? '';
                    panelSubtitle.textContent = panel.subtitle;
                    panelUrl.href = panel.url;
                    if (panel.url === '' || panel.url === '#') {
                        panelUrl.classList.add('hidden');
                    } else {
                        panelUrl.classList.remove('hidden');
                    }
                    const reassuranceHeader = document.querySelector(`#reassurance-header-${panel.porte}`);
                    const reassurance = document.querySelector(`#reassurance-${panel.porte}`);
                    if (reassuranceHeader) {
                        panelReassuranceHeader.innerHTML = reassuranceHeader.innerHTML as string;
                    }
                    if (reassurance) {
                        panelReassurance.innerHTML = reassurance.innerHTML as string;
                    }
                    this.rightLayerOpened = true;
                    document.body.classList.add('overflow-hidden');
                }
            },
            closeRightPanel() {
                this.rightLayerOpened = false;
                document.body.classList.remove('overflow-hidden');
            },
            getAllFiltersNumber() {
                this.allFilter = this.materials.length + this.vitrage.length + this.colorGroups.length;
            },
            getUrlParams() {
              const urlParams = new URLSearchParams(window.location.search);
              this.materials = urlParams.getAll('materials[]');
              this.vitrage = urlParams.getAll('vitrage[]');
              this.colorGroups = urlParams.getAll('colorGroups[]');
            },
            handleFilter(el) {
                this.getAllFiltersNumber();
              const type = el.dataset.type;
              if (el.checked) {
                this[type].push(el.value);
              } else {
                this[type] = this[type].filter((item) => item !== el.value);
              }
              this.addParamsToUrl(type, this.materials);
            },
            addParamsToUrl() {
              const url = new URL(window.location.href);
              const filterTypes = ['materials', 'vitrage', 'colorGroups'];
              const queryArray : string[] = [];
              filterTypes.forEach(type => {
                this[type].forEach(value => {
                  queryArray.push(`${type}[]=${encodeURIComponent(value)}`);
                })
              })
              url.search = queryArray.join('&');
              window.history.replaceState({}, '', url);
            },
            openFiltersLayer() {
              if (!this.$store.global.isMobile) return;
              this.filtersOpen = true;
              document.body.classList.add('overflow-hidden');
            },
            resetFiltersParams() {
              this.materials = [];
              this.vitrage = [];
              this.colorGroups = [];
              this.addParamsToUrl();
              const url = new URL(window.location.href);
              url.search = url.searchParams.toString();
              window.history.replaceState({}, '', url);
            this.getAllFiltersNumber();
            },
            closeFiltersLayer() {
              if (!this.$store.global.isMobile) return;
              this.filtersOpen = false;
              document.body.classList.remove('overflow-hidden');
            }
        };
    });
});

const rules: FavoriteRules = {
    zip: ['required'],
    city: ['required'],
    email: ['required', 'email', 'noPlusInEmail'],
    firstname: ['required'],
    lastname: ['required'],
    phone: ['required'],
};

document.addEventListener('alpine:init', () => {
    Alpine.data('initFavorites', () => {
        return {
            ...{
                send,
                ...getFieldValidation(rules),
            },
            ...{
                favorites: {},
                maxFavorites: 5,
                isFavoritesDrawerOpened: false,
                hasBeenAutoOpenedOnce: false,
                displayEmailModal: false,
                displayShareShopModal: false,
                email: null,
                zipCity: null,
                rgpd: false,
                rgpdPhone: false,
                rgpdEmail: false,
                hasLoadedFavorites: false,
                confirmation: false,
                buttonDisable: true,
                loading: false,
                validationError: false,
                errorMessages: [],
                results: [] as City[],
                serverMessages: {},
                openMaxItemModal: false,
                saveFavoritesInLocalStorage() {
                    setUserFavorites('doors', this.favorites);
                },
                getFavoritesFromLocalStorage() {
                    this.favorites = getUserFavorites('doors') ?? {};
                },
                getFavorites() {
                    if (!this.hasLoadedFavorites) {
                        this.hasLoadedFavorites = true;
                        this.getFavoritesFromLocalStorage();
                        this.isFavoritesDrawerOpened = true;
                    }

                    return this.favorites;
                },
                openFavoritesDrawer() {
                    // SetTimeOut to load Alpine template to get real height of the favorites panel
                    setTimeout(() => {
                        this.$refs.favoriteAccrodion.style.height = this.$refs.favoriteContainer.getBoundingClientRect().height + 'px';
                        this.isFavoritesDrawerOpened = true;
                    }, 100);
                },
                addPanelToFavorites(slug: string, name: string, material: string, img: string, color: number) {
                    this.getFavorites()[slug] = {
                        slug: slug,
                        name: name,
                        material: material,
                        img: img,
                        color: color,
                    };

                    this.openFavoritesDrawer();
                    this.saveFavoritesInLocalStorage();
                },
                removePanelFromFavorites(slug: string) {
                    if (this.getFavorites()[slug]) {
                        delete this.getFavorites()[slug];

                        this.saveFavoritesInLocalStorage();
                    }
                },
                panelIsInFavorites(slug: string) {
                    return !!this.getFavorites()[slug];
                },
                canAddPanelToFavorites() {
                    return Object.keys(this.getFavorites()).length < this.maxFavorites;
                },
                canShowFavoritesPanel() {
                    return Object.keys(this.getFavorites()).length > 0;
                },
                getFavoritesCountInPanel() {
                    return Object.keys(this.getFavorites()).length;
                },
                toggleFavoritesDrawer() {
                    if (this.isFavoritesDrawerOpened) {
                        this.$refs.favoriteAccrodion.style.height = '0px';
                    } else {
                        setTimeout((this.$refs.favoriteAccrodion.style.height = this.$refs.favoriteContainer.getBoundingClientRect().height + 'px'), 300);
                    }
                    this.isFavoritesDrawerOpened = !this.isFavoritesDrawerOpened;
                },
                getFavoritesRange(remaining = false) {
                    let length = this.maxFavorites;

                    if (!remaining) {
                        length = Object.keys(this.getFavorites()).length;
                    } else {
                        length = this.maxFavorites - Object.keys(this.getFavorites()).length;
                    }

                    return Array.from({ length: length }, (_, i) => i).map((i) => {
                        if (remaining) {
                            return Object.keys(this.getFavorites()).length + (i + 1);
                        }

                        return i;
                    });
                },
                cancelFavorites() {
                    this.favorites = {};
                    this.saveFavoritesInLocalStorage();
                },
                getFavoriteByNumber(number: number) {
                    const favoriteKeys = Object.keys(this.getFavorites());

                    if (favoriteKeys[number]) {
                        return this.getFavorites()[favoriteKeys[number]];
                    }

                    return null;
                },
                hasOpenedModal() {
                    return this.displayEmailModal || this.displayShareShopModal;
                },
                openEmailModal() {
                    this.displayShareShopModal = false;
                    this.displayEmailModal = true;

                    document.body.style.overflow = 'hidden';
                },
                openShareShopModal() {
                    this.displayEmailModal = false;
                    this.displayShareShopModal = true;

                    document.body.style.overflow = 'hidden';
                },
                closeModal() {
                    this.displayShareShopModal = false;
                    this.displayEmailModal = false;
                    this.confirmation = false;

                    document.body.style.overflow = '';
                },
                validateAllfields(element: HTMLFormElement): void {
                    const form = element.closest('form');
                    if (!form) {
                        return;
                    }
                    const zip = form.querySelector('[name$="[zip]"]') as HTMLInputElement;
                    const email = form.querySelector('[name$="[email]"]') as HTMLInputElement;
                    let validZip = false;
                    // Test if zip code is valid
                    if (!zip) {
                        return;
                    }
                    setTimeout(() => {
                        storeLocatorAutocomplete(zip.value)
                            .then((cities) => {
                                this.results = cities;
                                console.log(this.results);
                                const allResult = (this.results = JSON.parse(JSON.stringify(this.results)));
                                allResult.forEach((el) => {
                                    console.log(zip.value);
                                    if (el.codesPostaux.length > 1)
                                        el.codesPostaux.forEach((subEl) => {
                                            const result = subEl + ' ' + el.nom;
                                            if (zip?.value == result) {
                                                validZip = true;
                                                console.log('postaux');
                                            }
                                        });
                                    else {
                                        const result = el.codesPostaux[0] + ' ' + el.nom;
                                        if (zip?.value == result) {
                                            validZip = true;
                                            console.log('post');
                                        }
                                    }
                                });
                                console.log(validZip);
                                this.checkValidation(form, email, zip, validZip);
                            })
                            .catch(() => {
                                this.checkValidation(form, email, zip, validZip);
                            });
                    }, 600);
                },
                // Validate all fields of the form
                checkValidation(form: HTMLFormElement, email: HTMLInputElement, zip: HTMLInputElement, validZip: boolean) {
                    const firstname = form.querySelector('[name$="[firstname]"]') as HTMLInputElement | null;
                    const lastname = form.querySelector('[name$="[lastname]"]') as HTMLInputElement | null;
                    const phone = form.querySelector('[name$="[phone]"]') as HTMLInputElement | null;

                    const values: Record<string, string | null> = {
                        email: email ? email.value : null,
                        zip: validZip && zip ? zip.value : null,
                    };
                    const fieldRules: Record<string, string[]> = {
                        email: rules.email,
                        zip: rules.zip,
                    };

                    if (firstname) {
                        values.firstname = firstname.value;
                        fieldRules.firstname = rules.firstname ?? ['required'];
                    }
                    if (lastname) {
                        values.lastname = lastname.value;
                        fieldRules.lastname = rules.lastname ?? ['required'];
                    }
                    if (phone) {
                        values.phone = phone.value;
                        fieldRules.phone = rules.phone ?? ['required'];
                    }

                    const validation = iodine.assert(values, fieldRules);
                    if (validation.valid) {
                        this.buttonDisable = false;
                    } else {
                        this.buttonDisable = true;
                    }
                },
                replaceFormNameByZero(form: HTMLFormElement): void {
                    /**
                     * Remplace toutes les  occurences  de "express_quotation_form3" par "express_quotation_form0"
                     * dans les attributs [name] des inputs enfants du formulaire afin de
                     * correspondre avec la déclaration faite dans le controller back
                     */
                    const formNumberKey = form.name.match(/\d+/);
                    if (formNumberKey !== null) {
                        form.name = form.name.replace(`${formNumberKey}`, '0');
                        Array.from(form.querySelectorAll('[name^="express_"]')).forEach((element: Element) => {
                            element.setAttribute('name', (element.getAttribute('name') as string).replace('form' + formNumberKey, 'form0'));
                        });
                    }
                },
                retrieveSelectedColors() {
                    const colorValues: number[] = [];
                    const colorFields: HTMLInputElement[] = Array.from(document.querySelectorAll(`input[type="checkbox"][name="colorGroup"]`));

                    if (colorFields.length > 0) {
                        colorFields.forEach((input) => {
                            if (input?.checked) {
                                if (input?.value) {
                                    colorValues.push(parseInt(input.value));
                                }
                            }
                        });
                    }

                    return colorValues;
                },
                async submit(formSlug) {
                    this.buttonDisable = true;
                    this.loading = true;

                    const form = this.$refs[`form_${formSlug}`];

                    if (form instanceof HTMLFormElement) {
                        this.replaceFormNameByZero(form);
                        const formData = new FormData(form);
                        const favoritesKey = `${formSlug}_form[favorites]`;
                        const colorsKey = `${formSlug}_form[colors]`;

                        formData.delete(favoritesKey);
                        formData.append(favoritesKey, JSON.stringify(this.getFavorites()));
                        formData.append(colorsKey, JSON.stringify(this.retrieveSelectedColors()));

                        try {
                            await send(formData, form.action);
                            this.confirmation = true;
                            this.loading = false;
                            this.buttonDisable = false;

                            // @ts-ignore
                        } catch (e: unknown) {
                            const err = e as ApiError;
                            this.serverMessages = {};
                            this.serverMessages[formSlug] = [];

                            Object.keys(err).forEach((k) => {
                                this.serverMessages[formSlug].push(...err[k]);
                            });

                            this.confirmation = false;
                            this.loading = false;
                            this.buttonDisable = false;
                        } finally {
                            this.buttonDisable = false;
                        }
                    }
                },
            },
        };
    });
});

class DoorListingComponent {
    private currentFilters: FilterParams = {
        page: 1,
        limit: 27,
        search: '',
        materials: [],
        vitrage: [],
        colorGroups: [],
    };

    private loading = false;
    private panels: Record<string, Panel> = {};
    private pagination: PaginationInfo = { currentPage: 1, totalPages: 1, totalCount: 0, limit: 9 };
    private reassurances: HTMLTemplateElement[] = [];
    private reassuranceHeaders: HTMLTemplateElement[] = [];
    private removedBlocks: Array<{ element: HTMLElement; nextSibling: Node | null; parent: HTMLElement }> = [];

    constructor() {
        this.init();
    }

    private init(): void {
        this.initFilters();
        this.bindEvents();
        const search = new URLSearchParams(window.location.search);
        if (search.has('materials[]') || search.has('vitrage[]') || search.has('colorGroups[]') || search.has('page')) {
            this.loadPanels();
        }
        this.loadReassurances();
        this.loadReassuranceHeaders();
    }

     private initFilters(): void {
        const url = new URL(window.location.href);
        const params = new URLSearchParams(url.search);

        this.currentFilters.materials = params.getAll("materials[]");
        this.currentFilters.vitrage = params.getAll("vitrage[]");
        this.currentFilters.colorGroups = params.getAll("colorGroups[]").map((id) => parseInt(id));
        this.currentFilters.page = parseInt(params.get("page") ?? '1', 10);

        // Materials
        const materialInputs = document.querySelectorAll('input[name="material"]') as NodeListOf<HTMLInputElement>;
        materialInputs.forEach((input) => {
            if (this.currentFilters.materials) {
                input.checked = this.currentFilters.materials.includes(input.value);
            }
        });

        // Vitrage
        const vitrageInputs = document.querySelectorAll('input[name="vitrage"]') as NodeListOf<HTMLInputElement>;
        vitrageInputs.forEach((input) => {
            if (this.currentFilters.vitrage) {
                input.checked = this.currentFilters.vitrage.includes(input.value);
            }
        });

        // Color Groups
        const colorInputs = document.querySelectorAll('input[name="colorGroup"]') as NodeListOf<HTMLInputElement>;
        colorInputs.forEach((input) => {
            const value = parseInt(input.value);
            if (this.currentFilters.colorGroups) {
                input.checked = this.currentFilters.colorGroups.includes(value);
            }
        });
    }

    private bindEvents(): void {
        // Search input
        const searchInput = document.getElementById('search') as HTMLInputElement;
        if (searchInput) {
            let timeout: NodeJS.Timeout;
            searchInput.addEventListener('input', (e) => {
                clearTimeout(timeout);
                timeout = setTimeout(() => {
                    this.currentFilters.search = (e.target as HTMLInputElement).value;
                    this.currentFilters.page = 1;
                    this.loadPanels();
                }, 300);
            });
        }

        // Material filters
        const materialInputs = document.querySelectorAll('input[name="material"]') as NodeListOf<HTMLInputElement>;
        materialInputs.forEach((input) => {
            input.addEventListener('change', () => {
                this.updateArrayFilter('materials', input.value, input.checked);
                this.currentFilters.page = 1;
                this.loadPanels();
                updatePageTitle(1)
                updatePageMetaTitle(1)
                updatePageCanonical(1)
            });
        });

        // Vitrage filters
        const vitrageInputs = document.querySelectorAll('input[name="vitrage"]') as NodeListOf<HTMLInputElement>;
        vitrageInputs.forEach((input) => {
            input.addEventListener('change', () => {
                this.updateArrayFilter('vitrage', input.value, input.checked);
                this.currentFilters.page = 1;
                this.loadPanels();
                updatePageTitle(1)
                updatePageMetaTitle(1)
                updatePageCanonical(1)
            });
        });

        // Color group filters
        const colorInputs = document.querySelectorAll('input[name="colorGroup"]') as NodeListOf<HTMLInputElement>;
        colorInputs.forEach((input) => {
            input.addEventListener('change', () => {
                const colorGroupId = parseInt(input.value);
                this.updateArrayFilter('colorGroups', colorGroupId, input.checked);
                this.currentFilters.page = 1;
                this.loadPanels();
                updatePageTitle(1)
                updatePageMetaTitle(1)
                updatePageCanonical(1)
            });
        });

        // Clear filters button
        const clearFiltersBtn = document.getElementById('clearFilters');
        if (clearFiltersBtn) {
            clearFiltersBtn.addEventListener('click', () => {
                this.clearAllFilters();
            });
        }
    }

    private updateArrayFilter(filterName: keyof FilterParams, value: any, checked: boolean): void {
        const filterArray = this.currentFilters[filterName] as any[];
        if (!filterArray) return;

        if (checked) {
            if (!filterArray.includes(value)) {
                filterArray.push(value);
            }
        } else {
            const index = filterArray.indexOf(value);
            if (index > -1) {
                filterArray.splice(index, 1);
            }
        }
    }

    private async loadPanels(): Promise<void> {
        if (this.loading) return;

        this.loading = true;
        this.showLoading(true);

        try {
            const params = new URLSearchParams();

            if (this.currentFilters.page) params.append('page', this.currentFilters.page.toString());
            if (this.currentFilters.limit) {
                params.append('limit', this.currentFilters.limit.toString());
            }
            if (this.currentFilters.search) params.append('search', this.currentFilters.search);

            this.currentFilters.materials?.forEach((material) => params.append('materials[]', material));
            this.currentFilters.vitrage?.forEach((vitrage) => params.append('vitrage[]', vitrage));
            this.currentFilters.colorGroups?.forEach((colorGroup) => params.append('colorGroups[]', colorGroup.toString()));

            const grid = document.querySelector('#door-listing-grid');
            const loadingClasses = ['opacity-5', 'pointer-events-none'];
            grid?.classList.add(...loadingClasses);
            const response = await fetch(`/api/door-listing/panels?${params.toString()}`);

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const data: ApiResponse = await response.json();

            this.panels = data.panels;
            this.pagination = data.pagination;

            this.renderPanels();
            this.renderPagination();
            this.updateAvailableFilters(data.availableFilters);
            grid?.classList.remove(...loadingClasses);
        } catch (error) {
            console.error('Error loading panels:', error);
            this.showError('Erreur lors du chargement des panneaux. Veuillez réessayer.');
        } finally {
            this.loading = false;
            this.showLoading(false);
        }
    }

    private async loadReassurances(): Promise<void> {
        const reassurances = document.querySelectorAll('[data-template-reassurance]');
        reassurances.forEach((reassurance) => {
            this.reassurances[reassurance.id] = reassurance.innerHTML;
        });
    }

    private async loadReassuranceHeaders(): Promise<void> {
        const reassuranceHeaders = document.querySelectorAll('[data-template-reassurance-header]');
        reassuranceHeaders.forEach((reassurance) => {
            this.reassuranceHeaders[reassurance.id] = reassurance.innerHTML;
        });
    }

    private renderPanels(): void {
        const container = document.getElementById('panelsGrid') as HTMLElement;
        if (!container) return;

        // Update results info
        this.updateResultsInfo();

        if (Object.keys(this.panels).length === 0) {
            container.innerHTML = '<div class="col-span-full text-center py-12"><p class="text-gray-500 text-lg">Aucun produit ne correspond à vos filtres.</br>Essayez d’élargir vos critères ou de modifier votre recherche</p><button onclick="window.doorListing.clearAllFilters()" @click="resetFiltersParams()" class="mx-auto mt-4 w-fit px-4 py-2 text-brand-01 lg:hover:text-brand-01-dark trans-default font-bold gap-1 flex items-center"><i class="icon icon--lg fa-regular fa-arrow-rotate-right text-lg" aria-hidden="true"></i>Reinitialiser</button></div>';
            return;
        }

        let html = '';
        Object.entries(this.panels).forEach(([, panel]) => {
            if (!panel.name || !panel.colors || panel.colors.length === 0) return;

            window['panelsData'][panel.slug] = {
                name: panel.name,
                porte: panel.porte,
                subtitle: panel.subtitle,
                url: panel.url,
                defaultColor: {
                    packshot: panel.defaultColor.packshot ?? null,
                    facade: panel.defaultColor.facade ?? null,
                },
            };

            html += `
            <div class="panel bg-white group cursor-pointer" 
              @mouseover="preloadFacadeRightPanel('${panel.slug}')" 
              @click="openRightPanel('${panel.slug}')"
              @click="openRightPanel('${panel.slug}')">

            <div class="relative">
                <div class="favorite-btn absolute top-2 right-0 sm:right-2 text-gray-500 z-10 w-6 h-6">
                    <div x-transition.opacity x-show="!panelIsInFavorites('${panel?.slug}') && canAddPanelToFavorites()"
                        @click.stop="addPanelToFavorites('${panel?.slug}', '${panel?.name}', '${panel?.material}', '${panel?.defaultColor?.packshot}', '${panel?.defaultColor?.color_group_id}')">
                        <i class="absolute icon icon--lg fa-regular fa-heart text-xl trans-default" aria-hidden="true"></i>
                    </div>
                    <div x-transition.opacity x-cloak x-show="panelIsInFavorites('${panel?.slug}')"
                         @click.stop="removePanelFromFavorites('${panel?.slug}')">
                        <i class="absolute text-secondary-01-light icon icon--lg fa-solid fa-heart text-xl trans-default" aria-hidden="true"></i>
                    </div>
                    <div x-transition.opacity x-cloak @click="$event.stopImmediatePropagation(); openMaxItemModal = true"
                         x-show="!canAddPanelToFavorites() && !panelIsInFavorites('${panel?.slug}')">
                        <i class="absolute icon icon--lg fa-regular fa-heart-circle-minus text-xl trans-default" aria-hidden="true"></i>
                    </div>
                </div>
        `;

            html += `<div class="color-images relative" data-color="${panel.defaultColor?.color_group_id}">
                    <div class="h-[180px] sm:h-[250px] relative group">`;

            if (panel.defaultColor.packshot) {
                html += this.renderImage(`${panel.defaultColor.packshot}`, 'z-1 max-sm:w-[80%] max-sm:left-1/2 max-sm:-translate-x-1/2 max-sm:top-1/2 max-sm:-translate-y-1/2');
            }

            if (panel.defaultColor.facade) {
                html += this.renderImage(panel.defaultColor.facade, 'opacity-0 trans-default lg:group-hover:opacity-100 z-2');
            }

            html += `</div>
            </div>`;

            html += `
            <div class="flex items-center mt-2">
              <h3 class="font-semibold text-lg lg:group-hover:text-brand-01 trans-default">${panel?.name}</h3>
              <i class="icon icon--lg fa-regular fa-chevron-right block text-brand-01 text-base opacity-0 lg:group-hover:translate-x-2 lg:group-hover:opacity-100 trans-default" aria-hidden="true"></i>
            </div>
            <span>${panel?.subtitle}</span>
            </div>
          </div>
          </div>
          `;
        });

        container.innerHTML = html;
    }

    private renderImage(imageUrl: string, classes = ''): string {
        return `<img data-twic-src="${imageUrl}" class="absolute w-full h-full object-cover ${classes}" alt="Panneau de porte" />`;
    }

    private renderPagination(): void {
        const container = document.querySelector('.pagination-container') || this.createPaginationContainer();
        const totalPages = this.pagination.totalPages;

        if (totalPages <= 1) {
            container.innerHTML = '';
            return;
        }

        let html = '<div class="pagination mx-auto flex justify-between gap-2 w-full lg:w-[718px] items-center">';

        // Previous button
        //if (this.pagination.currentPage > 1) {
        html += `<button class="btn btn--md max-lg:!px-[10px] w-fit ${this.pagination.currentPage > 1 ? 'btn--secondary' : 'btn--secondary btn--disabled pointer-events-none'}" onclick="doorListing.goToPage(${this.pagination.currentPage - 1})"><span class="max-lg:hidden">Précédent</span><i class="icon icon--lg fa-regular fa-chevron-left block  lg:!hidden text-white" aria-hidden="true"></i></button>`;
        // }

        // Page numbers
        const startPage = Math.max(1, this.pagination.currentPage - 2);
        const endPage = Math.min(totalPages, this.pagination.currentPage + 2);
        html += `<div>`;
        if (startPage > 1) {
            html += `<button class="px-1 lg:hover:text-brand-01 trans-default" onclick="doorListing.goToPage(${1})">${1}</button>`;
            html += `<span>…</span>`;
        }
        for (let i = startPage; i <= endPage; i++) {
            const active = i === this.pagination.currentPage ? 'font-bold' : '';
            html += `<button class="px-1 lg:hover:text-brand-01 trans-default ${active}" onclick="doorListing.goToPage(${i})">${i}</button>`;
        }
        if (endPage < totalPages) {
            html += `<span>…</span>`;
            html += `<button class="px-1 lg:hover:text-brand-01 trans-default" onclick="doorListing.goToPage(${totalPages})">${totalPages}</button>`;
        }
        html += `</div>`;

        // Next button
        // if (this.pagination.currentPage < this.pagination.totalPages) {
        html += `<button class="btn btn--md max-lg:!px-[10px] w-fit ${this.pagination.currentPage < this.pagination.totalPages ? 'btn--secondary' : 'btn--secondary btn--disabled pointer-events-none'}" onclick="doorListing.goToPage(${this.pagination.currentPage + 1})"><span class="max-lg:hidden">Suivant</span><i class="icon icon--lg fa-regular fa-chevron-right block lg:!hidden text-white" aria-hidden="true"></i></button>`;
        // }

        html += '</div>';
        // html += `<div class="text-center mt-2 text-sm text-gray-600">
        //   ${this.pagination.totalCount} panneaux trouvés (page ${this.pagination.currentPage} sur ${this.pagination.totalPages})
        // </div>`;

        container.innerHTML = html;
    }

    private createPaginationContainer(): HTMLElement {
        const container = document.createElement('div');
        container.className = 'pagination-container col-span-12';

        const gridContainer = document.querySelector('.col-span-12.lg\\:col-span-9.grid');
        if (gridContainer && gridContainer.parentNode) {
            gridContainer.parentNode.insertBefore(container, gridContainer.nextSibling);
        }

        return container;
    }

    private updateAvailableFilters(availableFilters: ApiResponse['availableFilters']): void {
        // Update material filter counts and disable unavailable options
        const materialInputs = document.querySelectorAll('input[name="material"]') as NodeListOf<HTMLInputElement>;
        materialInputs.forEach((input) => {
            const material = availableFilters.materials.find((m) => m.material === input.value);
            const label = input.nextElementSibling as HTMLElement;
            if (label) {
                if (material) {
                    label.textContent = `${label.textContent?.split(' (')[0]} (${material.count})`;
                    input.disabled = false;
                    label.classList.remove('opacity-30');
                } else {
                    label.textContent = `${label.textContent?.split(' (')[0]} (0)`;
                    input.disabled = !input.checked; // Keep enabled if already selected
                    label.classList.add('opacity-30');
                }
            }
        });

        // Update vitrage filter counts
        const vitrageInputs = document.querySelectorAll('input[name="vitrage"]') as NodeListOf<HTMLInputElement>;
        vitrageInputs.forEach((input) => {
            const vitrage = availableFilters.vitrageTypes.find((v) => v.vitrage_type === input.value);
            const label = input.nextElementSibling as HTMLElement;
            if (label) {
                if (vitrage) {
                    label.textContent = `${label.textContent?.split(' (')[0]} (${vitrage.count})`;
                    input.disabled = false;
                    label.classList.remove('opacity-30');
                } else {
                    label.textContent = `${label.textContent?.split(' (')[0]} (0)`;
                    input.disabled = !input.checked;
                    label.classList.add('opacity-30');
                }
            }
        });

        // Update color group filter counts
        const colorInputs = document.querySelectorAll('input[name="colorGroup"]') as NodeListOf<HTMLInputElement>;
        colorInputs.forEach((input) => {
            const colorGroupId = parseInt(input.value);
            const colorGroup = availableFilters.colorGroups.find((c) => c.id === colorGroupId);
            const label = input.parentElement as HTMLElement;
            if (label) {
                const span = label.querySelector('span');
                if (span) {
                    if (colorGroup) {
                        span.innerHTML = span.innerHTML.split('(')[0] + '(' + colorGroup.count + ')';
                        label.classList.remove('opacity-30');
                        input.disabled = false;
                    } else {
                        span.innerHTML = span.innerHTML.split('(')[0] + '(0)';
                        input.disabled = !input.checked;
                        label.classList.add('opacity-30');
                    }
                }
            }
        });
    }

    private showLoading(show: boolean): void {
        const container = document.querySelector('.col-span-12.lg\\:col-span-9.grid') as HTMLElement;
        if (!container) return;

        if (show) {
            container.style.opacity = '0.5';
            container.style.pointerEvents = 'none';
        } else {
            container.style.opacity = '1';
            container.style.pointerEvents = 'auto';
        }
    }

    private showError(message: string): void {
        const container = document.querySelector('.col-span-12.lg\\:col-span-9.grid') as HTMLElement;
        if (container) {
            container.innerHTML = `<div class="col-span-12 text-red-500 text-center p-4">${message}</div>`;
        }
    }

    public goToPage(page: number): void {
        const url = new URL(window.location.href);
        const query = new URLSearchParams(url.search);
        if (page > 1) {
            query.set('page', page.toString());
            url.search = query.toString();
            window.history.replaceState({}, '', url);

            updatePageTitle(page)
            updatePageMetaTitle(page)
            updatePageCanonical(page)

            // quand on navigue, on supprime tous les bloc flex
            // Store elements before removing them (only if not already stored)
            if (this.removedBlocks.length === 0) {
                const elements = Array.from(document.querySelectorAll('#mainContent [id^="block-"], #mainContent [data-test="ReassuranceFaq"], #mainContent .BlockOpinion')) as HTMLElement[];
                elements.forEach(element => {
                    this.removedBlocks.push({
                        element: element,
                        nextSibling: element.nextSibling,
                        parent: element.parentElement as HTMLElement
                    });
                    element.remove();
                });
            }

            const grid = document.querySelector('#door-listing-grid');
            this.currentFilters.page = page;
            this.loadPanels();
            if (grid) {
                grid.scrollIntoView({ behavior: "smooth" });
            }
        } else {
            // Page 1: trigger a page load with all query params except 'page'
            query.delete('page');
            url.search = query.toString();
            console.log(url.toString());
            window.location.href = url.toString();
        }
    }

    private clearAllFilters(): void {
        // Reset filters
        this.currentFilters = {
            page: 1,
            limit: 27,
            search: '',
            materials: [],
            vitrage: [],
            colorGroups: [],
        };

        // Clear form inputs
        const searchInput = document.getElementById('search') as HTMLInputElement;
        if (searchInput) searchInput.value = '';

        const checkboxes = document.querySelectorAll('input[type="checkbox"]') as NodeListOf<HTMLInputElement>;
        checkboxes.forEach((checkbox) => {
            checkbox.checked = false;
            checkbox.disabled = false;
        });

        // Reload panels
        this.loadPanels();
    }

    private updateResultsInfo(): void {
        const resultsInfo = document.querySelector('.results-info') as HTMLElement;
        if (resultsInfo) {
            /*const start = (this.pagination.currentPage - 1) * this.pagination.limit + 1;*/
            /*const end = Math.min(start + Object.keys(this.panels).length - 1, this.pagination.totalCount);*/

            resultsInfo.innerHTML = `
        <span class="font-bold">
          ${this.pagination.totalCount} résultat${this.pagination.totalCount > 1 ? 's' : ''}
        </span>
      `;
        }
    }
}

// Initialize the component when the DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
  (window as any).doorListing = new DoorListingComponent();
});

export default DoorListingComponent;
